export function scrollElementIntoView(element, behavior = 'smooth', delay = 0) {
  setTimeout(() => element.scrollIntoView({ behavior }), delay);
}
